module.exports = __webpack_public_path__ + "img/hacienda-resort-3.8cd9b159.jpg";